import { useTrans } from "@/utils/useTrans";
import Image from "next/image";
import React from "react";

const BASE_PATH = "/images/tactsuit/common";

export default function OfficiallyMetaCertified() {
  const { t } = useTrans(["tactsuit"]);

  return (
    <div className="w-full">
      <div className="relative mx-auto hidden aspect-[1196/200] h-[200px] w-full max-w-[1196px] overflow-hidden rounded-2xl tablet:block">
        <Image
          fill
          alt="Officially Meta Certified"
          className="object-cover"
          src={`${BASE_PATH}/made_for_meta_desktop@2x.jpg`}
        />
        <div className="absolute inset-0 flex items-center">
          <div className="relative left-[calc(10%)] flex flex-col items-center gap-y-5">
            <Image
              src={"/svgs/mfm-horizontal-filled.svg"}
              width={147}
              height={32}
              alt="MFM"
            />
            <Description>
              {t(
                "Official product certified directly by Meta under the Made for Meta program.",
              )}
            </Description>
          </div>
        </div>
      </div>

      <div className="relative block w-full overflow-hidden rounded-lg bg-blue-10 p-4 tablet:hidden">
        <div className="flex flex-col items-center justify-center gap-y-2">
          <Image
            src={"/svgs/mfm-horizontal-filled.svg"}
            width={147}
            height={32}
            alt="MFM"
          />
          <Description>
            {t(
              "Official product certified directly by Meta under the Made for Meta program.",
            )}
          </Description>
        </div>
      </div>
    </div>
  );
}

const Description = ({ children }: React.PropsWithChildren) => (
  <h2 className="max-w-[280px] text-center text-sm font-400 text-coolgray-90 laptop:whitespace-pre-wrap">
    {children}
  </h2>
);
